import { Button, makeStyles, Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import React, { FC, useState } from 'react';
import convertSubmitOrderErrorMessage from '../../../../domain/usecases/ConvertSubmitOrderErrorMessage';

const useStyles = makeStyles(theme => ({
  errorMessage: {
    margin: theme.spacing(2),
    textAlign: 'center'
  },
  button: {
    textTransform: 'none',
    marginLeft: 5
  }
}));

const SubmitErrorMessage: FC<{ message?: string; submitError?: any }> = ({
  message,
  submitError
}) => {
  const classes = useStyles();
  const [isShowDetail, setIsShowDetail] = useState(false);

  return (
    <>
      <Typography className={classes.errorMessage} color="error">
        {isEmpty(message)
          ? 'This might be network relating issue. Please try again later or contact our customer support'
          : convertSubmitOrderErrorMessage(message || '')}
        {isShowDetail ? (
          <Typography>{JSON.stringify(submitError, null, 2)}</Typography>
        ) : (
          submitError && (
            <Button
              onClick={() => setIsShowDetail(true)}
              className={classes.button}
              color="primary"
              size="small"
            >
              Show more error detail
            </Button>
          )
        )}
      </Typography>
    </>
  );
};

export default SubmitErrorMessage;
